import gql from 'graphql-tag'

export const updateUserPassword = (user_id, password) => ({
	mutation: gql`
		mutation ($user_id: bigint!, $password: String!) {
			update_users_by_pk(
				pk_columns: { id: $user_id }
				_set: { password: $password }
			) {
				id
			}
		}
	`,
	variables: { user_id, password }
})
